import type { OwaDate } from '../schema';
import asDate from '../adapters/asDate';

// Functional replacements for the instance member functions;
// These will allow OwaDate to become a plain JS object, so it can be serialized.
export const getDate = (date: OwaDate): number => asDate(date).getDate();
export const getDay = (date: OwaDate): number => asDate(date).getDay();
export const getHours = (date: OwaDate): number => asDate(date).getHours();
export const getMilliseconds = (date: OwaDate): number => asDate(date).getMilliseconds();
export const getMinutes = (date: OwaDate): number => asDate(date).getMinutes();
export const getMonth = (date: OwaDate): number => asDate(date).getMonth();
export const getSeconds = (date: OwaDate): number => asDate(date).getSeconds();
export const getYear = (date: OwaDate): number => asDate(date).getFullYear();
export const getTimestamp = (date: OwaDate): number => asDate(date).getTime();
export const getTimezoneOffset = (date: OwaDate): number => asDate(date).getTimezoneOffset();

// These functions return strings with the UTC value of the given date, similar to JavaScript's Date.
export const getUTCString = (date: OwaDate): string => new Date(getTimestamp(date)).toUTCString();
export const getISOString = (date: OwaDate): string => new Date(getTimestamp(date)).toISOString();
export const getJSON = (date: OwaDate): string => new Date(getTimestamp(date)).toJSON();

// These functions return strings with the time-zone specific value of the given date, with the ISO format.
export const getDateString = (date: OwaDate): string => asDate(date).toDateString();
export const getISOStringWithOffset = (date: OwaDate): string => asDate(date).toString();
export const getISODateString = (date: OwaDate): string => asDate(date).toDateString();
export const getISOTimeString = (date: OwaDate): string => asDate(date).toTimeString();

export const toLocaleDateString = (date: OwaDate): string => asDate(date).toLocaleDateString();
export const toLocaleTimeString = (date: OwaDate): string => asDate(date).toLocaleTimeString();
export const toLocaleString = (date: OwaDate): string => asDate(date).toLocaleString();
